\:host
    width: 100%
    height: 50px
    position: relative

.RentwareButtonSimple 
    position: relative 
    height: 100%
    min-width: 200px
    font-size: 14px
    font-weight: 700
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    flex-shrink: 0
    border-radius: 0
    box-sizing: border-box
    overflow: hidden
    background-position: center
    &:focus
        outline: none
        box-shadow: none

.DefaultButtonSimple
    background-color: rgb($globalButtonBackgroundPrimary)
    color: rgb($globalButtonFontPrimary)
.DefaultButtonSimpleActive
    cursor: pointer
    &:hover
        background: rgb($globalButtonBackgroundSecondary) radial-gradient(circle, transparent 1%, rgb($globalButtonBackgroundSecondary) 1%) center/15000%
    &:active
        background-size: 100%
        transition: background 0s
        background-color: rgb($globalButtonBackgroundPrimary)

.ConfigButtonSimple
    background-color: rgb(73, 185, 196) 
    color: rgb(255, 255, 255)
    font-family: Nunito
    border-radius: 10px
    box-shadow: 0px 3px 5px 0px #0000001A, 0px 2px 1px 0px #FFFFFF40 inset, 0px 2px 1px 0px #0000001A
.ConfigButtonSimpleActive
    cursor: pointer
    &:hover
        background: rgb(73, 185, 196)  radial-gradient(circle, transparent 1%, rgb(73, 185, 196)  1%) center/15000%
    &:active
        background-size: 100%
        transition: background 0s
        background-color: rgb(73, 185, 196) 
    &:focus
        box-shadow: 0px 3px 5px 0px #0000001A, 0px 2px 1px 0px #FFFFFF40 inset, 0px 2px 1px 0px #0000001A

.BackendButtonSimple
    background-color: #46435B
    color: rgb(255, 255, 255)
    font-family: Nunito
    box-shadow: 0px 3px 5px 0px #0000001A, 0px 2px 1px 0px #FFFFFF40 inset, 0px 2px 1px 0px #0000001A
.BackendButtonSimpleActive
    cursor: pointer
    &:hover
        background: #46435B radial-gradient(circle, transparent 1%, #46435B 1%) center/15000%
    &:active
        background-size: 100%
        transition: background 0s
        background-color: #46435B
    &:focus
        box-shadow: 0px 3px 5px 0px #0000001A, 0px 2px 1px 0px #FFFFFF40 inset, 0px 2px 1px 0px #0000001A


.FilterButtonSimple
    background-color: rgb($globalSettingsBackgroundPrimary)
    color: rgb($globalSettingsFontPrimary)
    border-top: 1px solid rgb($globalSettingsStrokeTertiary)
.FilterButtonSimpleActive
    cursor: pointer
    &:hover
        border-top: 1px solid rgb($globalSettingsStrokeSecondary)
        background: rgb($globalSettingsBackgroundSecondary) radial-gradient(circle, transparent 1%, rgb($globalSettingsBackgroundSecondary) 1%) center/15000%
    &:active
        background-size: 100%
        transition: background 0s
        background-color: rgb($globalSettingsBackgroundPrimary)

.InactiveContainer
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background: rgb($globalSettingsBackgroundPrimary)
    opacity: 0.5
.WaitingContainer
    cursor: wait



